import { useState, useMemo } from "react";
import useGetOneBusiness from "../api/useGetOneBusiness";
import useGetFollowing from "../api/useGetFollowing";
import useGetFollowers from "../api/useGetFollowers";
import useGetFollowedContent from "../api/useGetFollowedPosts";
import useSuggestedFollows from "../api/useSuggestedFollows";
import useGetCategories from "../api/useGetCategories";
import useGetAllUserContent from "../api/useGetUserPosts";

const useConnect = (user) => {
  const [showMenu, setShowMenu] = useState(false);
  const [sortNewest, setSortNewest] = useState(true);

  const token = user.accessToken;
  const { biz } = useGetOneBusiness(user, token);
  const { following } = useGetFollowing(user, token);
  const { followers } = useGetFollowers(user, token);
  const { subscribedContent } = useGetFollowedContent(user, token);
  const { suggestedFollows } = useSuggestedFollows(user, token);
  const { categories } = useGetCategories(token);
  const { userContent, refetch } = useGetAllUserContent(user, token);

  const businessInfo = biz[0] ?? {};

  const displayName =
    (businessInfo?.firstName ?? "") + " " + (businessInfo?.lastName ?? "");

  const filteredSuggestions = useMemo(
    () => suggestedFollows?.filter((item) => item?.userEmail !== user?.email) ?? [],
    [suggestedFollows, user?.email]
  );

  const sortedPosts = useMemo(() => {
    const merged = [...subscribedContent, ...userContent.flat()];
    return sortNewest ? [...merged].reverse() : merged;
  }, [subscribedContent, userContent, sortNewest]);

  const toggleSort = () => setSortNewest((prev) => !prev);

  return {
    token,
    businessInfo,
    displayName,
    following,
    followers,
    categories,
    suggestedFollows: filteredSuggestions,
    sortedPosts,
    sortNewest,
    toggleSort,
    showMenu,
    setShowMenu,
    refetch,
  };
};

export default useConnect;
